import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import validators from '../../utils/validators';
import Overlay from '../../forms/_common/Overlay';
import FormErrors from '../../forms/_common/FormErrors';
import ErrorMessage from '../../forms/_common/ErrorMessage';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Form from './Form';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';
import EventCloseDialog from '../event.close';

EventCloseExtendDialog.propTypes = {
  event: PropTypes.object.isRequired
};

export default function EventCloseExtendDialog(props) {
  const { event } = props;

  const { history } = usePageRouter();

  const [showEventCloseDialog, setShowEventCloseDialog] = useState(false);

  const [data, setData] = useState({
    action: ''
  });
  const [showErrors, setShowErrors] = useState(false);

  function onSubmit() {
    if (data.action === 'extend') {
      props.onCancel();
      history.push(`/post-event/${event.id}/date`);
    }

    if (data.action === 'close') {
      setShowEventCloseDialog(true);
    }
  }

  function onChange(name, value) {
    const nextData = _.merge({}, data);
    nextData[name] = value;
    setData(nextData);
  }

  if (showEventCloseDialog) {
    return (
      <EventCloseDialog {...props} />
    );
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-md">
      <Overlay isVisible={false}>
        <FormErrors data={data} validators={{
          action: [validators.isRequired]
        }}>
          {({errors, hasError}) => {
            return (
              <Form
                data={data}
                errors={errors}
                showErrors={showErrors}
                onChange={onChange}
                onSubmit={() => hasError ? setShowErrors(true) : onSubmit()}
                onCancel={props.onCancel}
                alert={showErrors ? (
                  <ErrorMessage>
                    Please fill in all required fields.
                  </ErrorMessage>
                ) : null}
                event={event}
              />
            )
          }}
        </FormErrors>
      </Overlay>
    </DialogTemplate>
  );
};
